import React from 'react';
import AddRounded from '@material-ui/icons/AddRounded';
import ButtonBase from '@material-ui/core/ButtonBase';

import Component from '../Component';
import styles from './styles';
import { merge, isEmptyList, isEmptyString, path, deepCheck } from '../../utils';
import { secondary } from '../../resources/styles';
import ImageUploadFragment from '../UploadFragment/Image';
import Collapse from '../Collapse';

class ImageUploader extends Component {

    uploaderRef = React.createRef();

    styles = styles;

    state = {
        files: path(this.props, 'urls', []).map(url => ({ id: Math.floor(Math.random() * new Date().getTime() + Math.random() * 10), url })),
    }

    prefill = () => this.setState({ files: path(this.props, 'urls', []).map(url => ({ id: Math.floor(Math.random() * new Date().getTime() + Math.random() * 10), url })) });

    componentDidMount = () => this.props.urls && this.prefill();

    componentDidUpdate = pProps => pProps.urls !== this.props.urls && this.prefill();

    onImageChange = e => {
        const files = e.target.files;
        if (files == null || files.length === 0) return;

        const newFiles = [];
        Object.keys(files).forEach(id => newFiles.push({ id: Math.floor(Math.random() * new Date().getTime() + Math.random() * 10), file: files[id] }));
        newFiles.length = this.props.limit - this.state.files.length;

        this.setState({ refresher: new Date().getTime(), files: [].concat(this.state.files).concat(newFiles) });
        e.target.value = null;
    }

    isMultiple = () => isEmptyList(this.state.files) || this.state.files.length < this.props.limit - 1;

    renderAdd = () => <Collapse orientation='horizontal' in={this.state.files.length < this.props.limit}><div>
        <input ref={this.uploaderRef} accept="image/*" style={{ display: 'none' }} id="image-add-button" type='file' onChange={this.onImageChange} />
        <ButtonBase style={merge(this.gs('item_container'), this.gs('add_container'))} TouchRippleProps={{ style: secondary }} onClick={() => this.uploaderRef.current.click()}>
            <AddRounded />
            <div style={this.gs('add_text')}>{this.guc('add_an_image')}</div>
        </ButtonBase>
    </div></Collapse>;

    onUploadSuccess = id => url => this.setState(pState => ({ files: pState.files.map(item => id === item.id ? { ...item, url } : item) }));

    onDelete = id => () => this.setState(prevState => ({ files: prevState.files.filter(item => item.id !== id) }));

    renderImage = item => <ImageUploadFragment key={item.id} file={item.file} url={item.url} onSuccess={this.onUploadSuccess(item.id)} onDelete={this.onDelete(item.id)} uploadApi={this.props.uploadApi} />;

    render = () => <div style={this.gs('container')}>
        {this.renderAdd()}
        {!isEmptyList(this.state.files) && this.state.files.map(this.renderImage)}
    </div>;

    getUrls = () => this.state.files.filter(item => !isEmptyString(item.url)).map(item => item.url);

}

ImageUploader.defaultProps = {
    limit: 1,
    uploadApi: 'v1/oam/upload?type=oam&file_name_prefix=property',
};

export default ImageUploader;